/**
 * Returns a Tailwind class for avatar/initial circles so each row gets a different color.
 * Used in AssignSeatModal and IntervatGrantModal.
 */
export function getInitialColorClass(idx: number): string {
  const colors = [
    'bg-purple-200 text-purple-700',
    'bg-green-200 text-green-700',
    'bg-blue-200 text-blue-700',
    'bg-pink-200 text-pink-700',
    'bg-yellow-200 text-yellow-700',
    'bg-gray-200 text-gray-700',
    'bg-purple-100 text-purple-700',
    'bg-green-100 text-green-700',
    'bg-blue-100 text-blue-700',
    'bg-pink-100 text-pink-700',
    'bg-yellow-100 text-yellow-700',
    'bg-primary-25 text-gray-700',
  ];
  return colors[idx % colors.length];
}
